export default __webpack_public_path__ + "static/media/backlesswhite.67739503.png";